
import React from 'react';
import { styled, Theme } from '@mui/material/styles';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import HalfCircle from './icons/HalfCircle';

export type CheckableCircularProgressProps = {
  progress: number,
  checked: boolean | null,
  small?: boolean
};

const StaticCircularProgress = styled(CircularProgress)(({ color }: CircularProgressProps) => ({
  padding: '4px',
  color: color === 'primary' ? '#0052cc' : '#C1C7D0'
}));

const DynamicCircularProgress = styled(CircularProgress)(({}: CircularProgressProps) => ({
  padding: '4px',
  color: '#0052cc',
  position: 'absolute',
  left: 0,
  top: 0.5
}));

const CustomHalfCircle = styled(({ small, ...props }: { small?: boolean }) => <HalfCircle {...props}  />)(({ small }: { small?: boolean }) => ({
  color: '#0065FF',
  position: 'absolute',
  fontSize: small ? 6 : 10,
  top: small ? 9 : 7,
  left: small ? 9 : 7
}));

const Circle = styled(({ small, ...props }: { small?: boolean }) => <div {...props} />)(({ small }: { small?: boolean }) => ({
  backgroundColor: '#0065FF',
  borderRadius: '50%',
  position: 'absolute',
  height: small ? 6 : 10,
  width: small ? 6 : 10,
  top: small ? 9 : 7,
  left: small ? 9 : 7
}));

export default ({ progress, checked, small }: CheckableCircularProgressProps) => {
  return (<>
    <StaticCircularProgress
      color={progress === 100 ? 'primary' : 'secondary'}
      size={24}
      variant='determinate'
      value={100}
    />
    {(progress > 0 && progress < 100)
      && <DynamicCircularProgress
        size={24}
        variant='determinate'
        value={progress}
      />
    }
    {checked === true && <Circle small={small} />}
    {checked === null && <CustomHalfCircle small={small} />}
  </>);
}